import { NotificationTypes } from './notification.types';

export class Notification {
    id;
    message;
    type;

    constructor(message = '', type = NotificationTypes.SUCCESS) {
        this.message = message;
        this.type = type;
        this.id = Notification.count++;
    }

    static count = 0;
}


// WEBPACK FOOTER //
// ./src/store/modules/notifications/notification.model.js